import React, { useState, useEffect } from 'react';
import { Search, FolderOpen, Download, Mail, ChevronRight, ChevronLeft, FileText, Loader2 } from 'lucide-react';
import Page from './Page';


import {utils} from './utils/index'

const REACT_APP_API_HOST = utils.config.REACT_APP_API_HOST;

export default function MyFilesDashboard() {
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);

  const [emailStatus, setEmailStatus] = useState('idle');
  const [emailMessage, setEmailMessageState] = useState('');


  const setEmailMessage = (text) => {
    setEmailMessageState(text);
    setTimeout(() => {
      setEmailMessageState('');
    },7000)
    
  }

  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    total: 0,
    limit: 50,
    hasNextPage: false,
    hasPrevPage: false
  });

  const [searchQuery, setSearchQuery] = useState('');
  const [selectedFiles, setSelectedFiles] = useState([]);


  var apiHost = REACT_APP_API_HOST;
  // משיכת נתונים מהשרת
  const fetchReceipts = async () => {
    setLoading(true);
    try {
      let url = `${apiHost}/api/receipts?page=${pagination.currentPage}&limit=${pagination.limit}`;
      if (searchQuery) {
        url += `&search=${encodeURIComponent(searchQuery)}`;
      }

      const response = await fetch(url, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
          'Content-Type': 'application/json'
        }
      });

      const resData = await response.json();
      if (resData.success) {
        setFiles(resData.data);
        setPagination(prev => ({
          ...prev,
          totalPages: resData.pagination.totalPages,
          total: resData.pagination.total,
          hasNextPage: resData.pagination.hasNextPage,
          hasPrevPage: resData.pagination.hasPrevPage
        }));
      }
    } catch (error) {
      console.error("Error fetching receipts:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReceipts();
  }, [pagination.currentPage, pagination.limit, searchQuery]);

  // --- פונקציות המייל החדשות ---

  // 1. שליחת קובץ בודד
  const handleSendSingleEmail = async (file) => {
    if (emailStatus === 'sending') return;
    setEmailStatus('sending');
    setEmailMessage('');

    try {
      // const targetFile = file.filename || `${file.fileName}`;
      const response = await fetch(REACT_APP_API_HOST + '/api/receipts/send-file', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({ receiptId : file._id  }),
      });

      if (!response.ok) throw new Error();
      setEmailStatus('success');
      setEmailMessage('הקובץ נשלח למייל בהצלחה!');
    } catch (error) {
      setEmailStatus('error');
      setEmailMessage('שגיאה בשליחת המייל.');
    }
  };

  // 2. שליחת מסומנים - בקשת HTTP אחת עם מערך קבצים!
  const handleSendSelectedToEmail = async (month, monthFiles) => {
    if (emailStatus === 'sending') return;

    const selectedMonthFiles = monthFiles.filter(f => selectedFiles.includes(f._id));
    const fileNames = selectedMonthFiles.map(f => f.filename || `${f.fileName}`);

    if (fileNames.length === 0) return;

    setEmailStatus('sending');
    setEmailMessage('');

    try {
      // שליחת בקשה אחת מרוכזת עם המערך
      const response = await fetch( REACT_APP_API_HOST+ '/api/receipts/send-multiple-files', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({ fileNames: fileNames }), // שולח מערך [file1, file2...]
      });

      if (!response.ok) throw new Error();

      setEmailStatus('success');
      setEmailMessage('כל הקבצים המסומנים נשלחו במייל אחד!');
      setSelectedFiles([]); // איפוס הסימונים לאחר שליחה מוצלחת
    } catch (error) {
      setEmailStatus('error');
      setEmailMessage('שגיאה בשליחת הקבצים המסומנים.');
    }
  };

  // 3. שליחת כל החודש - שולח חודש/שנה והשרת שולף עצמאית מה-DB
  const handleSendMonthToEmail = async (month, monthFiles) => {
    if (emailStatus === 'sending') return;

    // שליפת שנה וחודש (לפי הקובץ הראשון בקבוצה כדי שיהיה מדויק)
    const sampleDate = monthFiles[0]?.createdAt ? new Date(monthFiles[0].createdAt) : new Date();
    const monthNumber = sampleDate.getMonth() + 1; // חודש מ-1 עד 12
    const yearNumber = sampleDate.getFullYear();

    setEmailStatus('sending');
    setEmailMessage('');

    try {
      const response = await fetch(  REACT_APP_API_HOST + '/api/receipts/send-month', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({
          month: monthNumber,
          year: yearNumber,
          monthNameHebrew: month // גיבוי אם השרת מעדיף את השם בעברית ("יוני")
        }),
      });

      if (!response.ok) throw new Error();

      setEmailStatus('success');
      setEmailMessage(`בקשה לשליחת כל קבצי חודש ${month} התקבלה בהצלחה!`);
    } catch (error) {
      setEmailStatus('error');
      setEmailMessage('שגיאה בשליחת קבצי החודש.');
    }
  };

  // הורדת קובץ
  const handleDownloadFile = (file) => {
    const targetFile = file.filename || `${file.fileName}`;
    const downloadUrl = `${REACT_APP_API_HOST}/files/${encodeURIComponent(targetFile)}`;
    window.open(downloadUrl, '_blank');
  };

  // הלוגיקה של קיבוץ החודשים והשאר נשארת זהה לחלוטין...
  const getMonthName = (dateString) => {
    if (!dateString) return 'אחר';
    const date = new Date(dateString);
    const months = ['ינואר', 'פברואר', 'מרץ', 'אפריל', 'מאי', 'יוני', 'יולי', 'אוגוסט', 'ספטמבר', 'אוקטובר', 'נובמבר', 'דצמבר'];
    return months[date.getMonth()];
  };

  const groupedFiles = files.reduce((groups, file) => {
    const month = getMonthName(file.createdAt);
    if (!groups[month]) groups[month] = [];
    groups[month].push(file);
    return groups;
  }, {});

  const monthsOrder = Object.keys(groupedFiles);

  const handlePageChange = (direction) => {
    setPagination(prev => ({
      ...prev,
      currentPage: direction === 'next' ? prev.currentPage + 1 : Math.max(prev.currentPage - 1, 1)
    }));
  };

  const handleItemsPerPageChange = (e) => {
    setPagination(prev => ({ ...prev, limit: parseInt(e.target.value), currentPage: 1 }));
    setSelectedFiles([]);
  };

  const handleSelectFile = (id) => {
    setSelectedFiles(prev => prev.includes(id) ? prev.filter(fileId => fileId !== id) : [...prev, id]);
  };

  const handleSelectAllInMonthGroup = (monthFiles) => {
    const fileIds = monthFiles.map(f => f._id);
    const allSelected = fileIds.every(id => selectedFiles.includes(id));
    if (allSelected) {
      setSelectedFiles(prev => prev.filter(id => !fileIds.includes(id)));
    } else {
      setSelectedFiles(prev => Array.from(new Set([...prev, ...fileIds])));
    }
  };

  return (
    <Page totalFilesCount={pagination.total}>

      {/* Toast חיווי ממורכז למטה */}
      {emailMessage && (
        <div className={`fixed bottom-4 left-1/2 -translate-x-1/2 z-50 p-4 rounded-xl shadow-lg border text-sm font-medium transition-all max-w-md w-auto whitespace-nowrap text-right ${emailStatus === 'success' ? 'bg-emerald-50 border-emerald-200 text-emerald-800' :
            emailStatus === 'error' ? 'bg-rose-50 border-rose-200 text-rose-800' :
              'bg-indigo-50 border-indigo-200 text-indigo-800'
          }`}>
          <div className="flex items-center gap-2 justify-end">
            <span>{emailMessage}</span>
            {emailStatus === 'sending' && <Loader2 className="w-4 h-4 animate-spin text-indigo-600" />}
          </div>
        </div>
      )}

      {/* כותרת ושורת חיפוש */}
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 border-b border-slate-200 pb-6 mb-6">
        <div>
          <h2 className="text-xl font-bold text-slate-900">ארכיון קבצים שהורדו</h2>
          <p className="text-xs text-slate-500 mt-1">צפייה, סינון ודפדוף קבצים מחולקים לפי חודשי פעילות.</p>
        </div>

        <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 w-full md:w-auto">
          <div className="flex items-center gap-2 bg-white border border-slate-200 rounded-xl px-3 py-1.5 shadow-sm">
            <label className="text-xs font-medium text-slate-500 whitespace-nowrap">הצג פריטים:</label>
            <select
              value={pagination.limit}
              onChange={handleItemsPerPageChange}
              className="bg-transparent text-xs font-semibold text-slate-700 outline-none cursor-pointer text-right"
            >
              <option value={10}>10 פריטים</option>
              <option value={50}>50 פריטים</option>
              <option value={100}>100 פריטים</option>
            </select>
          </div>

          <div className="relative w-full sm:w-64 md:w-72">
            <span className="absolute inset-y-0 right-0 flex items-center pr-4 pointer-events-none text-slate-400">
              <Search className="w-4 h-4" />
            </span>
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => {
                setSearchQuery(e.target.value);
                setPagination(prev => ({ ...prev, currentPage: 1 }));
              }}
              placeholder="חיפוש לפי שם חברה..."
              className="w-full pr-10 pl-4 py-2.5 bg-white border border-slate-200 rounded-xl text-sm text-slate-800 placeholder-slate-400 shadow-sm focus:outline-none focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/10 transition-all duration-200 text-right"
            />
          </div>
        </div>
      </div>

      {loading && (
        <div className="text-center py-6 text-sm text-slate-500 font-medium">
          טוען נתונים מהשרת...
        </div>
      )}

      {!loading && monthsOrder.length === 0 && (
        <div className="text-center py-12 bg-white border border-slate-200 rounded-2xl shadow-sm">
          <FolderOpen className="w-12 h-12 mx-auto text-slate-300 mb-3" />
          <p className="text-sm font-medium text-slate-600">לא נמצאו קבצים התואמים לחיפוש שלך.</p>
        </div>
      )}

      {/* רשימת החודשים והטבלאות */}
      {!loading && monthsOrder.map(month => {
        const allMonthFiles = groupedFiles[month] || [];
        const totalFiles = allMonthFiles.length;

        const isAllMonthSelected = allMonthFiles.length > 0 && allMonthFiles.every(f => selectedFiles.includes(f._id));
        const hasSelectedInMonth = allMonthFiles.some(f => selectedFiles.includes(f._id));

        return (
          <div key={month} className="bg-white border border-slate-200 rounded-2xl shadow-sm overflow-hidden mb-6">

            <div className="px-6 py-4 bg-slate-50/50 border-b border-slate-100 flex flex-col sm:flex-row gap-3 sm:items-center justify-between">
              <div className="flex items-center gap-3">
                <input
                  type="checkbox"
                  checked={isAllMonthSelected}
                  onChange={() => handleSelectAllInMonthGroup(allMonthFiles)}
                  className="w-4 h-4 rounded border-slate-300 text-indigo-600 focus:ring-indigo-500 cursor-pointer"
                />
                <h3 className="font-bold text-slate-800 text-sm">{month}</h3>
                <span className="text-xs bg-slate-100 text-slate-600 px-2 py-1 rounded-md font-medium">
                  {totalFiles} פריטים בעמוד זה
                </span>
              </div>

              <div className="flex items-center gap-2">
                <button
                  disabled={!hasSelectedInMonth || emailStatus === 'sending'}
                  onClick={() => handleSendSelectedToEmail(month, allMonthFiles)}
                  className="flex items-center gap-1.5 px-3 py-1.5 bg-emerald-50 hover:bg-emerald-100 text-emerald-700 disabled:bg-slate-50 disabled:text-slate-400 font-medium text-xs rounded-lg transition-colors border border-emerald-200/50 disabled:border-slate-200"
                >
                  <Mail className="w-3.5 h-3.5" />
                  שלח מסומנים למייל
                </button>

                <button
                  disabled={emailStatus === 'sending'}
                  onClick={() => handleSendMonthToEmail(month, allMonthFiles)}
                  className="flex items-center gap-1.5 px-3 py-1.5 bg-indigo-50 hover:bg-indigo-100 text-indigo-700 font-medium text-xs rounded-lg transition-colors border border-indigo-200/50 disabled:opacity-50"
                >
                  <Mail className="w-3.5 h-3.5" />
                  שלח את כל החודש למייל
                </button>
              </div>
            </div>

            <div className="w-full overflow-x-auto">
              <table className="w-full text-right border-collapse">
                <thead>
                  <tr className="bg-slate-50/30 border-b border-slate-100 text-slate-500 text-xs font-semibold">
                    <th className="p-4 w-12 text-center">בחר</th>
                    <th className="p-4">שם בית העסק</th>
                    <th className="p-4">קטגוריה</th>
                    <th className="p-4">מטבע</th>
                    <th className="p-4">סכום</th>
                    <th className="p-4">תאריך יצירה</th>
                    <th className="p-4 text-left pl-6">פעולות</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-100 text-sm text-slate-700">
                  {allMonthFiles.map(file => {
                    const isSelected = selectedFiles.includes(file._id);
                    return (
                      <tr
                        key={file._id}
                        className={`hover:bg-slate-50/40 transition-colors ${isSelected ? 'bg-indigo-50/30 hover:bg-indigo-50/40' : ''}`}
                      >
                        <td className="p-4 text-center">
                          <input
                            type="checkbox"
                            checked={isSelected}
                            onChange={() => handleSelectFile(file._id)}
                            className="w-4 h-4 rounded border-slate-300 text-indigo-600 focus:ring-indigo-500 cursor-pointer"
                          />
                        </td>

                        <td className="p-4 font-medium text-slate-800">
                          <div className="flex items-center gap-2.5">
                            <div className={`p-1.5 rounded-md ${isSelected ? 'bg-indigo-100 text-indigo-700' : 'bg-slate-100 text-slate-500'}`}>
                              <FileText className="w-4 h-4" />
                            </div>
                            <span className="truncate max-w-[200px] sm:max-w-xs block" title={file.companyName}>
                              {file.companyName || 'ללא שם חברה'}
                            </span>
                          </div>
                        </td>

                        <td className="p-4">
                          <span className="inline-flex items-center px-2 py-0.5 rounded-md text-xs font-medium bg-slate-100 text-slate-600 border border-slate-200/40">
                            {file.category || 'כללי'}
                          </span>
                        </td>

                        <td className="p-4 font-mono text-xs text-slate-500">
                          {file.currency || 'ILS'}
                        </td>

                        <td className="p-4 font-mono text-xs text-slate-500">
                          {file.rawAmountText || ''}
                        </td>

                        <td className="p-4 text-xs text-slate-500">
                          {file.createdAt ? new Date(file.createdAt).toLocaleDateString('he-IL') : '-'}
                        </td>

                        <td className="p-4 text-left pl-6">
                          <div className="flex items-center justify-end gap-1">
                            <button
                              disabled={emailStatus === 'sending'}
                              onClick={() => handleSendSingleEmail(file)}
                              title="שלח למייל"
                              className="p-1.5 hover:bg-slate-100 rounded-lg text-slate-400 hover:text-indigo-600 disabled:opacity-50 transition-colors"
                            >
                              <Mail className="w-4 h-4" />
                            </button>
                            <button
                              onClick={() => handleDownloadFile(file)}
                              title="הורד קובץ"
                              className="p-1.5 hover:bg-slate-100 rounded-lg text-slate-400 hover:text-indigo-600 transition-colors"
                            >
                              <Download className="w-4 h-4" />
                            </button>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        );
      })}

      {/* פג'ינציה גלובלית */}
      {pagination.totalPages > 1 && (
        <div className="px-6 py-4 bg-white border border-slate-200 rounded-2xl shadow-sm flex items-center justify-between text-xs mt-4">
          <button
            disabled={!pagination.hasPrevPage}
            onClick={() => handlePageChange('prev')}
            className="flex items-center gap-1 p-1 px-3 py-2 rounded-lg border border-slate-200 bg-white hover:bg-slate-50 disabled:opacity-50 disabled:pointer-events-none transition-colors font-medium text-slate-600"
          >
            <ChevronRight className="w-3.5 h-3.5" />
            הקודם
          </button>
          <span className="text-slate-500 font-medium">
            עמוד {pagination.currentPage} מתוך {pagination.totalPages}
          </span>
          <button
            disabled={!pagination.hasNextPage}
            onClick={() => handlePageChange('next')}
            className="flex items-center gap-1 p-1 px-3 py-2 rounded-lg border border-slate-200 bg-white hover:bg-slate-50 disabled:opacity-50 disabled:pointer-events-none transition-colors font-medium text-slate-600"
          >
            הבא
            <ChevronLeft className="w-3.5 h-3.5" />
          </button>
        </div>
      )}
    </Page>
  );
}